import type { SportId, SportConfig } from '../types/sport';
import type { TeamMode, ScoringMode } from '../types/activity';

const SPORT_ICONS: Record<SportId, string> = {
  volleyball: 'circle-dot',
  football: 'circle',
  basketball: 'circle-dot',
  tennis: 'target',
  table_tennis: 'table-tennis',
  badminton: 'feather',
  beach_volleyball: 'circle-dot',
  hockey: 'hockey',
};

export function getSportIcon(sportId: SportId): string {
  return SPORT_ICONS[sportId] ?? 'circle';
}

export function getSportLabel(sportId: SportId, locale: 'ru' | 'en' = 'ru'): string {
  const labels: Record<SportId, { ru: string; en: string }> = {
    volleyball: { ru: 'Волейбол', en: 'Volleyball' },
    football: { ru: 'Футбол', en: 'Football' },
    basketball: { ru: 'Баскетбол', en: 'Basketball' },
    tennis: { ru: 'Теннис', en: 'Tennis' },
    table_tennis: { ru: 'Настольный теннис', en: 'Table Tennis' },
    badminton: { ru: 'Бадминтон', en: 'Badminton' },
    beach_volleyball: { ru: 'Пляжный волейбол', en: 'Beach Volleyball' },
    hockey: { ru: 'Хоккей', en: 'Hockey' },
  };
  return labels[sportId]?.[locale] ?? sportId;
}

const TEAM_MODE_LABELS: Record<TeamMode, { ru: string; en: string }> = {
  none: { ru: 'без команд', en: 'no teams' },
  '2_teams': { ru: '2 команды', en: '2 teams' },
  n_teams: { ru: 'несколько команд', en: 'multiple teams' },
  pairs: { ru: 'парная игра', en: 'pairs' },
  individual: { ru: 'индивидуально', en: 'individual' },
};

const SCORING_MODE_LABELS: Record<ScoringMode, { ru: string; en: string }> = {
  none: { ru: 'без счёта', en: 'no score' },
  team_score: { ru: 'общий счёт', en: 'team score' },
  sets: { ru: 'по сетам', en: 'by sets' },
  individual_time: { ru: 'на время', en: 'timed' },
};

/**
 * Read-only one-line summary like "Теннис · парная игра · по сетам".
 * Used in CreateGameModal under the sport selector to clarify expectations
 * before the user fills the form.
 */
export function getSportSummary(config: SportConfig, locale: 'ru' | 'en' = 'ru'): string {
  const sportName = config.name[locale];
  const teamLabel = TEAM_MODE_LABELS[config.defaults.teamMode][locale];
  const scoringLabel = SCORING_MODE_LABELS[config.defaults.scoringMode][locale];
  return `${sportName} · ${teamLabel} · ${scoringLabel}`;
}
